import React, { useEffect, useState } from 'react';
import DialogContent from '@mui/material/DialogContent';
import ButtonRound from '../ButtonRound';
import TextField from '@mui/material/TextField';
import styles from './Modal.scss';
import UserRequest from '../../utils/UserRequest';
import Config from '../../utils/Config';
import useUser from '../../stores/useUser';
import trackApi from '../../utils/trackApi';

const userApiUrl = Config.get('userApi.url');

const VerificationCode = ({ prevStep, nextStep, values, handleCodeChange, setSalt, setCode, onSubmitAction, salt, code, pass, trackingSteps }) => {
    const [user] = useUser();
    const [isLoading, setIsLoading] = useState(false);
    const [errorList, setErrorList] = useState([]);

    const goToNextStep = e => {
        e.preventDefault();
        nextStep();
    }

    const goToPrevStep = e => {
        e.preventDefault();
        prevStep();
    }

    const sendVerificationCodeAgain = (ev: React.FormEvent) => {
        ev.preventDefault();
        setIsLoading(true);

        return UserRequest.postRequest(userApiUrl + '/user-api/user/doi?_format=json', {
            method: 'mail',
            action: 'send',
            mail: values.mail
        }, { timeout: 60000 })
            .then((res) => {
                // success
                setIsLoading(false);
                const data = res.getData();
                setSalt(data.data.salt);
                setCode('');
            })
            .catch((e) => {
                // reset state on error
                setIsLoading(false);
                const errorList = [];
                errorList.push({ id: 'mail', text: 'Die E-Mail konnte nicht gesendet werden.', fields: ['mail'] });
                setErrorList(errorList);
                return Promise.reject(e);
            });
    };

    const handleVerificateCode = (ev: React.FormEvent) => {
        //form validation
        const errorList = validateForm();
        if (errorList.length > 0) {
            setErrorList(errorList);
            return;
        }

        ev.preventDefault();
        setIsLoading(true);
        return UserRequest.postRequest(userApiUrl + '/user-api/user/doi?_format=json', {
            method: 'mail',
            action: 'check',
            mail: values.mail,
            salt: values.salt,
            secret: values.code,
            pass: pass
        }, { timeout: 60000 })
            .then((res) => {
                // success
                setIsLoading(false);
                goToNextStep(ev);
            })
            .catch((e) => {
                // reset state on error
                setIsLoading(false);
                const errorList = [];
                errorList.push({ id: 'code', text: e.responseData.errors?.title || "Der Verifizierungscode ist nicht korrekt.", fields: ['code'] });
                setErrorList(errorList);

                //if trackingSteps für doi is set then also track form error 
                if (trackingSteps) {
                    trackApi.wglEvent({ event: 'formError', event_name: 'formError', formErrorCode: 'doi verifizierungscode' });
                }
            });
    };

    const handleRegistration = (ev: React.FormEvent) => {
        //form validation
        const errorList = validateForm();
        if (errorList.length > 0) {
            setErrorList(errorList);
            return;
        }

        onSubmitAction(salt, code);
    }

    const validateForm = () => {
        const errorList = [];
        const regex = new RegExp(/(^\d*$)|(Backspace|Tab|Delete|ArrowLeft|ArrowRight)/);

        if (values.code == '') {
            errorList.push({ id: 'code', text: 'Bitte gib deinen Verifizierungscode ein.', fields: ['code'] });
        } else if (!values.code.match(regex)) {
            errorList.push({ id: 'code', text: 'Der Verifizierungscode darf ausschließlich aus Zahlen bestehen.', fields: ['code'] });
        } else if (values.code.length < 5 || values.code.length > 5) {
            errorList.push({ id: 'code', text: 'Der Verifizierungscode muss aus genau 5 Zahlen bestehen.', fields: ['code'] });
        }

        return errorList;
    };

    return (
        <div>
            <DialogContent dividers={false}>
                <p>Code gesendet an <b>{values.mail}</b></p>
                <p>Bitte gib hier den Code ein:</p>
                <div className={styles.verificationCode}>
                    <div>
                        <TextField
                            name="verificationCode"
                            value={values.code}
                            onChange={handleCodeChange}
                            label="Verifizierungscode"
                            required
                            inputMode="numeric"
                            type="text"
                        />
                        {errorList
                            .filter((e) => e.id === 'code')
                            .map((e) => (
                                <p className={styles.error} key={e.text}>
                                    {e.text}
                                </p>
                            ))}
                    </div>
                </div>
                <p>Kein Code erhalten?{' '}
                    {trackingSteps ? (
                        <ButtonRound
                            data-da-el-name="DOI Code erneut senden"
                            data-da-el-interaction="click"
                            data-da-el-target="Makler Registrierungsformular"
                            data-da-el-category="Formulare"
                            type="button"
                            variant="link"
                            onClick={(event) => {
                                sendVerificationCodeAgain(event);
                            }}
                        >
                            Erneut senden
                        </ButtonRound>
                    ) : (
                        <ButtonRound
                            type="button"
                            variant="link"
                            onClick={(event) => {
                                sendVerificationCodeAgain(event);
                            }}
                        >
                            Erneut senden
                        </ButtonRound>
                    )}
                    {' '}</p>
                <div className={styles.verificationCodeButtons}>
                    <ButtonRound type="submit" variant="outlined" className={'button button--secondary'} onClick={goToPrevStep}>
                        Zurück
                    </ButtonRound>
                    <ButtonRound type="submit" className={'button button--primary'} isLoading={isLoading} onClick={handleVerificateCode}>
                        Code verifizieren
                    </ButtonRound>

                </div>
            </DialogContent>
        </div>
    )
}

export default VerificationCode;